export class SubjectPivotCount {
    id:number;
    subject: string;
    className: string;
    language: string;
    totalQuestions: number;
    activeQuestions: number;
    inActiveQuestions: number;
    constructor(
        subject: string,
        className: string,
        language: string,
        totalQuestions: number,
        activeQuestions: number,
        inActiveQuestions: number,
    ) {
        this.subject = subject;
        this.className = className;
        this.language = language;
        this.totalQuestions = totalQuestions;
        this.activeQuestions = activeQuestions;
        this.inActiveQuestions = inActiveQuestions;
    }
}